// extracted by mini-css-extract-plugin
export var button = "transition-gallery-card-module--button--3c902";
export var container = "transition-gallery-card-module--container--4588f";
export var count = "transition-gallery-card-module--count--5e0a2";
export var dataBox = "transition-gallery-card-module--data-box--ef6c4";
export var dataRow = "transition-gallery-card-module--data-row--2d39c";
export var dataValue = "transition-gallery-card-module--data-value--71757";
export var date = "transition-gallery-card-module--date--5569b";
export var deleteButton = "transition-gallery-card-module--delete-button--62027";
export var footer = "transition-gallery-card-module--footer--95d1b";
export var iconBox = "transition-gallery-card-module--icon-box--ca907";
export var image = "transition-gallery-card-module--image--2b307";
export var imageBox = "transition-gallery-card-module--image-box--be05c";
export var noImage = "transition-gallery-card-module--no-image--62482";